// extracted by mini-css-extract-plugin
export default {"projects":"projectsLoader_projects__P8hnk","project":"projectsLoader_project__f+IZL","project-light-mode":"projectsLoader_project-light-mode__Tye5W"};